import { Fragment, useContext, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { ConvertToFloat } from "../../Layout/Common/common";
import { SHIPPING_METHOD } from "../../constants";
import { GlobalContext } from "../../Context/GlobalContext";

export const OrderSummaryList = ({ label, value }) => {
  const [amount, setAmount] = useState(null);
  const { deliveryMethod } = useContext(GlobalContext);
  useEffect(() => {
    {
      if (value === "TBA") {
        setAmount("TBA");
      } else {
        setAmount(ConvertToFloat(value));
      }
    }
  }, [label, value, deliveryMethod]);
  return (
    <Fragment>
      {amount && (
        <div className="order-summary-list">
          <p>{label}</p>
          {amount ? <span>{amount !== "TBA" && `$ ${amount}`}</span> : <Skeleton width={50} />}
        </div>
      )}
    </Fragment>
  );
};
